import { ClipboardList, Stethoscope, Package } from "lucide-react";
import tabletMockupImg from "@/assets/tablet-mockup.jpg";

const steps = [
  {
    icon: ClipboardList,
    step: "01",
    title: "Take a quick assessment",
    description:
      "Answer a few questions about your health, goals, and lifestyle.",
  },
  {
    icon: Stethoscope,
    step: "02",
    title: "Get reviewed by a licensed provider",
    description:
      "A medical professional determines if treatment is appropriate for you.",
  },
  {
    icon: Package,
    step: "03",
    title: "Receive your treatment",
    description:
      "If prescribed, your medication is shipped directly to your door.",
  },
];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-24">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-16 items-center max-w-6xl mx-auto">
          {/* Left: tablet image */}
          <div className="relative order-last md:order-first">
            <img
              src={tabletMockupImg}
              alt="Patient browsing the Elara Health platform on an iPad in a calming wellness setting"
              loading="lazy"
              width={928}
              height={1152}
              className="rounded-2xl shadow-lg w-full h-auto max-w-md mx-auto"
            />
          </div>

          {/* Right: steps */}
          <div>
            <div className="mb-10">
              <p className="text-sm font-semibold uppercase tracking-widest text-champagne mb-3">
                How It Works
              </p>
              <h2 className="font-display text-4xl md:text-5xl text-foreground mb-4">
                Three simple steps to get started.
              </h2>
              <p className="text-muted-foreground">
                From assessment to treatment, a clear path to better health.
              </p>
            </div>

            <div className="space-y-6">
              {steps.map((s) => (
                <div key={s.step} className="flex gap-5 group">
                  <div className="shrink-0">
                    <div className="w-14 h-14 rounded-2xl bg-secondary flex items-center justify-center text-foreground group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                      <s.icon size={24} />
                    </div>
                  </div>
                  <div>
                    <span className="text-xs font-bold uppercase tracking-widest text-champagne">
                      {s.step}
                    </span>
                    <h3 className="font-display text-xl text-foreground mt-0.5 mb-1">
                      {s.title}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {s.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
